var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11028)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_141_11028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8264 56.5196C94.8264 60.3539 93.3032 64.0311 90.592 66.7424C87.8807 69.4536 84.2035 70.9768 80.3692 70.9768C76.535 70.9768 72.8577 69.4536 70.1465 66.7424C67.4353 64.0311 65.9121 60.3539 65.9121 56.5196C65.9121 52.6854 67.4353 49.0081 70.1465 46.2969C72.8577 43.5857 76.535 42.0625 80.3692 42.0625C84.2035 42.0625 87.8807 43.5857 90.592 46.2969C93.3032 49.0081 94.8264 52.6854 94.8264 56.5196Z",
    fill: "#31BF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4875 67.7633C59.4875 69.4674 58.8105 71.1017 57.6056 72.3067C56.4006 73.5117 54.7662 74.1887 53.0621 74.1887C51.358 74.1887 49.7237 73.5117 48.5187 72.3067C47.3137 71.1017 46.6367 69.4674 46.6367 67.7633C46.6367 66.0592 47.3137 64.4248 48.5187 63.2198C49.7237 62.0149 51.358 61.3379 53.0621 61.3379C54.7662 61.3379 56.4006 62.0149 57.6056 63.2198C58.8105 64.4248 59.4875 66.0592 59.4875 67.7633Z",
    fill: "#FBB945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.105 67.7633C114.105 69.4674 113.428 71.1017 112.223 72.3067C111.018 73.5117 109.383 74.1887 107.679 74.1887C105.975 74.1887 104.341 73.5117 103.136 72.3067C101.931 71.1017 101.254 69.4674 101.254 67.7633C101.254 66.0592 101.931 64.4248 103.136 63.2198C104.341 62.0149 105.975 61.3379 107.679 61.3379C109.383 61.3379 111.018 62.0149 112.223 63.2198C113.428 64.4248 114.105 66.0592 114.105 67.7633Z",
    fill: "#1AD3BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3697 77.4004H46.6363C44.9322 77.4004 43.2979 78.0774 42.0929 79.2823C40.8879 80.4873 40.2109 82.1217 40.2109 83.8258V90.2512C40.2109 91.9553 40.8879 93.5896 42.0929 94.7946C43.2979 95.9996 44.9322 96.6766 46.6363 96.6766H80.3697V77.4004Z",
    fill: "#FBB945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.102 77.4004H80.3691V96.6766H114.102C115.807 96.6766 117.441 95.9996 118.646 94.7946C119.851 93.5896 120.528 91.9553 120.528 90.2512V83.8258C120.528 82.1217 119.851 80.4873 118.646 79.2823C117.441 78.0774 115.807 77.4004 114.102 77.4004Z",
    fill: "#1AD3BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4863 77.4004H81.9752C92.6205 77.4004 101.251 86.0313 101.251 96.6766H78.7625C68.1172 96.6766 59.4863 88.0457 59.4863 77.4004Z",
    fill: "#31BF5C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11028",
    x: 0.0521603,
    y: 0.52608,
    width: 160.635,
    height: 160.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.4739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11028"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_141_11028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.3174,
    height: 80.3174,
    fill: "white",
    transform: "translate(40.2109 29.2109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.f9431024dabe91f23e3b591cddbe9847.svg";
export { ForwardRef as ReactComponent };